import type { Lesson } from "./types";
import { wordAudioScope } from "./script";

export const EXPRESSIONS_CURRICULUM_ID = "curriculum-japanese-expressions";
export interface ExpressionSentence { title: string; text: string; meaning: string; scenes: string[]; activity: "situation" | "listen" | "reply" | "role"; }
export interface ExpressionLesson { id: string; category: string; title: string; icon: string; sentences: ExpressionSentence[]; }
const categories: Array<{ name: string; icon: string; rows: Array<[string, string, string, string, string]> }> = [
  { name: "인사해요", icon: "👋", rows: [
    ["아침에 선생님을 만나요", "おはようございます", "안녕하세요. (아침 인사)", "아침에 교실에 들어가 선생님을 만났어요.", "아침에 이웃 어른을 만났어요."],
    ["낮에 이웃을 만나요", "こんにちは", "안녕하세요. (낮 인사)", "낮에 산책하다 이웃을 만났어요.", "낮에 도서관 선생님을 만났어요."],
    ["저녁에 인사해요", "こんばんは", "안녕하세요. (저녁 인사)", "저녁에 이웃 어른을 만났어요.", "저녁에 가족의 손님이 오셨어요."],
    ["다음에 다시 만나요", "またあいましょう", "다음에 또 만나요.", "즐겁게 놀고 친구와 헤어져요.", "수업을 마치고 다음 만남을 약속해요."]
  ] },
  { name: "나를 소개해요", icon: "🙋", rows: [
    ["내 이름을 말해요", "はじんです", "하진입니다.", "새로운 선생님께 하진이라고 소개해요.", "처음 만난 친구에게 하진이라고 소개해요."],
    ["이름을 물어요", "おなまえは", "이름이 어떻게 되세요?", "새 친구의 이름을 알고 싶어요.", "처음 만난 사람에게 이름을 물어요."],
    ["내 나이를 말해요", "ろくさいです", "여섯 살입니다.", "여섯 살인 아이 역할로 나이를 소개해요.", "생일 모임에서 여섯 살이라고 말해요."],
    ["처음 만나 인사해요", "よろしくおねがいします", "잘 부탁드립니다.", "새 선생님께 자기소개를 마쳤어요.", "새 모둠 친구들에게 인사해요."]
  ] },
  { name: "대답해요", icon: "✅", rows: [
    ["이름을 부르면 대답해요", "はい", "네.", "선생님이 내 이름을 부르셨어요.", "가족이 나를 불렀어요."],
    ["맞는지 확인해요", "はい、そうです", "네, 맞습니다.", "선생님이 내 가방인지 물으셨어요. 맞아요.", "친구가 내가 고른 책인지 물어요. 맞아요."],
    ["다른 물건이라고 말해요", "いいえ、ちがいます", "아니요, 다릅니다.", "친구가 내 연필인지 물어요. 내 것이 아니에요.", "내가 찾던 장난감과 다른 장난감을 보여줘요."],
    ["설명을 듣고 대답해요", "わかりました", "알겠습니다.", "선생님의 활동 설명을 이해했어요.", "가족이 알려준 약속을 이해했어요."]
  ] },
  { name: "고마움을 전해요", icon: "🎁", rows: [
    ["도움을 받고 감사해요", "ありがとうございます", "감사합니다.", "선생님이 떨어진 책을 주워주셨어요.", "이웃이 문을 열어주셨어요."],
    ["선물을 받고 감사해요", "ありがとうございます", "감사합니다.", "생일 선물을 받았어요.", "가족에게 예쁜 그림책을 받았어요."],
    ["칭찬을 받고 감사해요", "ありがとうございます", "감사합니다.", "그림을 잘 그렸다고 칭찬받았어요.", "정리를 잘했다고 칭찬받았어요."],
    ["감사 인사에 답해요", "どういたしまして", "천만에요.", "친구를 도와주니 고맙다고 해요.", "물건을 건네니 감사 인사를 해요."]
  ] },
  { name: "미안함을 전해요", icon: "🙏", rows: [
    ["길을 막았을 때 말해요", "すみません", "죄송합니다.", "통로에서 다른 사람의 길을 막았어요.", "문 앞에서 다른 사람이 지나가기를 기다려요."],
    ["물건을 떨어뜨렸어요", "ごめんなさい", "미안합니다.", "친구의 장난감을 떨어뜨렸어요.", "친구의 그림을 실수로 구겼어요."],
    ["늦었을 때 사과해요", "おくれてすみません", "늦어서 죄송합니다.", "약속 장소에 늦게 도착했어요.", "수업에 늦게 들어왔어요."],
    ["괜찮다고 말해요", "だいじょうぶです", "괜찮습니다.", "친구가 실수한 뒤 사과해요.", "가족이 내가 괜찮은지 물어봐요."]
  ] },
  { name: "부탁해요", icon: "🤲", rows: [
    ["물을 부탁해요", "みずをください", "물을 주세요.", "식사 중 물을 마시고 싶어요.", "놀이터에서 놀고 물이 필요해요."],
    ["원하는 물건을 골라요", "これをください", "이것을 주세요.", "가게에서 원하는 빵을 가리켜요.", "마음에 드는 색연필을 골랐어요."],
    ["도움을 요청해요", "てつだってください", "도와주세요.", "혼자서 상자를 옮기기 어려워요.", "장난감을 정리하는 데 도움이 필요해요."],
    ["기다려 달라고 해요", "ちょっとまってください", "잠깐 기다려주세요.", "신발을 신는 동안 기다려 달라고 해요.", "그림을 마칠 때까지 기다려 달라고 해요."]
  ] },
  { name: "다시 알려주세요", icon: "👂", rows: [
    ["이해하지 못했어요", "わかりません", "모르겠습니다.", "선생님의 설명을 이해하지 못했어요.", "친구가 한 말의 뜻을 모르겠어요."],
    ["한 번 더 말해주세요", "もういちどおねがいします", "한 번 더 부탁드립니다.", "주변이 시끄러워 말을 못 들었어요.", "안내를 다시 듣고 싶어요."],
    ["천천히 말해주세요", "ゆっくりはなしてください", "천천히 말해주세요.", "상대가 너무 빠르게 말해요.", "설명을 천천히 듣고 싶어요."],
    ["물건 이름을 물어요", "これはなんですか", "이것은 무엇인가요?", "처음 보는 물건을 발견했어요.", "상자에서 낯선 도구를 꺼냈어요."]
  ] },
  { name: "내 마음을 말해요", icon: "💛", rows: [
    ["좋아하는 동물을 말해요", "ねこがすきです", "고양이를 좋아합니다.", "좋아하는 동물로 고양이를 골라요.", "고양이 그림을 보며 좋아한다고 말해요."],
    ["기쁜 마음을 말해요", "うれしいです", "기쁩니다.", "보고 싶었던 친구를 만났어요.", "원하던 선물을 받았어요."],
    ["슬픈 마음을 말해요", "かなしいです", "슬픕니다.", "소중한 장난감이 망가졌어요.", "친구와 헤어져서 슬퍼요."],
    ["재미있었다고 말해요", "たのしかったです", "즐거웠습니다.", "공원에서 즐겁게 놀고 돌아왔어요.", "재미있는 만들기 활동을 마쳤어요."]
  ] },
  { name: "내 상태를 말해요", icon: "🧒", rows: [
    ["배가 고파요", "おなかがすきました", "배가 고픕니다.", "점심시간이 되어 배가 고파요.", "한참 놀아서 배가 고파요."],
    ["목이 말라요", "のどがかわきました", "목이 마릅니다.", "달리기를 해서 목이 말라요.", "더운 날 산책하다 목이 말라요."],
    ["조금 피곤해요", "つかれました", "피곤합니다.", "오래 걸어서 쉬고 싶어요.", "운동을 마친 뒤 피곤해요."],
    ["아픈 곳을 말해요", "おなかがいたいです", "배가 아픕니다.", "배가 아파서 선생님께 알려요.", "집에서 가족에게 배가 아프다고 말해요."]
  ] },
  { name: "먹고 마셔요", icon: "🍚", rows: [
    ["먹기 전에 인사해요", "いただきます", "잘 먹겠습니다.", "점심을 먹기 전에 인사해요.", "가족과 저녁을 먹기 전에 인사해요."],
    ["맛을 표현해요", "おいしいです", "맛있습니다.", "맛있는 빵을 먹었어요.", "가족이 만든 음식을 먹었어요."],
    ["조금 더 부탁해요", "おかわりをください", "한 번 더 주세요.", "밥을 다 먹고 더 먹고 싶어요.", "급식에서 음식을 더 받고 싶어요."],
    ["먹고 나서 인사해요", "ごちそうさまでした", "잘 먹었습니다.", "점심을 다 먹었어요.", "가족과 저녁 식사를 마쳤어요."]
  ] },
  { name: "함께 활동해요", icon: "🧩", rows: [
    ["함께 놀자고 말해요", "いっしょにあそびましょう", "함께 놀아요.", "혼자 있는 친구에게 같이 놀자고 해요.", "모둠 친구들과 놀이를 시작해요."],
    ["차례를 물어요", "わたしのばんですか", "제 차례인가요?", "보드게임에서 내 차례인지 물어요.", "순서대로 발표할 때 차례를 물어요."],
    ["물건을 건네요", "どうぞ", "여기 있습니다. / 먼저 하세요.", "친구에게 색연필을 건네요.", "친구가 먼저 지나가도록 양보해요."],
    ["정중하게 거절해요", "すみません、いまはできません", "죄송하지만 지금은 할 수 없습니다.", "그림을 마쳐야 해서 지금 놀 수 없어요.", "해야 할 일이 있어 부탁을 바로 들어줄 수 없어요."]
  ] },
  { name: "허락을 구해요", icon: "🙌", rows: [
    ["앉아도 되는지 물어요", "すわってもいいですか", "앉아도 되나요?", "빈자리에 앉기 전에 물어요.", "선생님 곁의 의자에 앉아도 되는지 물어요."],
    ["만져도 되는지 물어요", "さわってもいいですか", "만져도 되나요?", "친구의 장난감을 만지기 전에 물어요.", "체험 활동의 물건을 만져도 되는지 물어요."],
    ["빌려도 되는지 물어요", "かりてもいいですか", "빌려도 되나요?", "친구의 지우개를 빌리고 싶어요.", "선생님의 색연필을 빌려도 되는지 물어요."],
    ["허락을 받고 감사해요", "ありがとうございます", "감사합니다.", "친구가 지우개를 빌려도 된다고 했어요.", "선생님이 물건을 사용해도 된다고 하셨어요."]
  ] }
];
export const EXPRESSION_CATEGORIES = categories.map((item) => item.name);
export const EXPRESSION_LESSONS: ExpressionLesson[] = categories.map((category, c) => ({
  id: `lesson-expression-category-${String(c + 1).padStart(2, "0")}`, category: category.name, title: category.name, icon: category.icon,
  sentences: category.rows.map(([title, text, meaning, scene, other], i) => ({
    title, text: text + (text.endsWith("か") || text === "おなまえは" ? "？" : "。"), meaning, scenes: [scene, other],
    activity: (["situation", "listen", "reply", "role"] as const)[i]
  }))
}));
export function expressionLesson(id: string) { return EXPRESSION_LESSONS.find((item) => item.id === id); }
export function expressionAudioReady(lesson: Lesson, plan: ExpressionLesson) {
  return plan.sentences.every(sentence => lesson.assets.some((item) => item.scope === wordAudioScope(sentence.text) && item.asset.assetType === "audio" && item.asset.qualityStatus === "approved"));
}
